import { useAuthData } from "@/context/auth-data-provider";
import { hasSubstitutionClaim } from "@/context/utils/token-substitution";

/**
 * Estado derivado da substituição na ótica display×token (Story 2.7):
 * - `NONE`    — sem substituição ativa.
 * - `PENDING` — `/auth/me` diz ativa, mas o token vigente ainda não carrega a claim (precisa reconciliar).
 * - `ACTIVE`  — ativa e o token já reflete (claim presente).
 */
export const SubstitutionStates = {
  NONE: "NONE",
  PENDING: "PENDING",
  ACTIVE: "ACTIVE",
} as const;

export type SubstitutionState =
  (typeof SubstitutionStates)[keyof typeof SubstitutionStates];

export function deriveSubstitutionState(
  active: boolean,
  hasClaim: boolean,
): SubstitutionState {
  if (!active) {
    return SubstitutionStates.NONE;
  }
  return hasClaim ? SubstitutionStates.ACTIVE : SubstitutionStates.PENDING;
}

export function useSubstitutionState(): SubstitutionState {
  const authData = useAuthData();
  const active = Boolean(authData?.substitution?.active);
  return deriveSubstitutionState(active, hasSubstitutionClaim());
}
